export default __webpack_public_path__ + "static/project-slide-7-768-700-03f80fa690cdfefe70133baac9a310a5.jpg";